import { gql } from "@apollo/client";

export const GET_ALL_USER_MANAGEMENT_LIST = gql`
  query AllUserManagementList {
    getAllUserManagementList {
      umd_id
      firstName
      lastName
      email
      status
      groups
      lastlogin
    }
  }
`;

export const GET_ALL_USER_GROUPS = gql`
  query AllUserGroups {
    getAllUserGroups {
    user_group
    group_desc
    is_portal_group
  }
  }
`;

export const GET_USER = gql`
  query GetUser($umdId: String!) {
  getUser(umd_id: $umdId) {
    umd_id
    firstName
    lastName
    phone
    email
    lastlogin
    createdAt
    createdBy
    updatedAt
    updatedBy
    accountName
    accountDescription
    status
    manager
    section
    requestAccessType
    assignedGroups {
      umd_id
      user_group
      group_desc
      is_portal_group
    }
    assignedLhds {
      umd_id
      lhd_id
      lhd_name
    }
    assignedSystems {
      umdId
      systemId
      systemName
      pwsId
    }
    assignedInstitutions {
      umd_id
      institutionId
      institutionName
      institutionLookupPattern
    }
  }
}
`;

export const UPDATE_USER_DATA = gql`
mutation UpdateUser($input: UpdateUserDataInput!) {
  updateUser(UpdateUserDataInput: $input)
}
`;

export const GET_ALL_INSTITUTIONS = gql`
  query GetAllInstitutions {
  getAllInstitutions {
    umd_id
    institutionId
    institutionName
  }
}
`;

export const GET_ALL_LHD = gql`
  query GetAllLHD {
  getAllLHD {
    umd_id
    lhd_id
    lhd_name
  }
}
`;

export const UPDATE_USER_PREFERENCE = gql`
  mutation UpdateUserPreference($key: UserPreferenceKey!, $value: Boolean!) {
    updateUserPreference(key: $key, value: $value)
  }
`;

export const GET_LOGGEDIN_USER_QUERY = gql`
  query {
    getLoggedInUser {
      umdId
      email
      firstName
      lastName
      phone
      isActive
      isStaff
      isSysAdmin
      isPortalUser
      userPreferences {
        reportHeaderCollapsed
      }
      assignments {
        umdId
        moduleCode
        moduleAssigned
        moduleRoute
        roleCode
        roleAssigned
      }
      systems {
        systemId
        pwsId
      }
      permissions
    }
  }
`;
